import { api } from 'api';
import { FUNC_DEFAULT } from 'constants';
import { isEmpty } from 'lodash';
import useProfileStore from './useProfileStore';

const useProfileAPI = () => {
  const { configOccupation, setProfileOccupation, setLoading } =
    useProfileStore();

  const getProfileRequest = async (token) => {
    try {
      let { data } = await api.getProfile(token);
      console.log(`⭐ useProfileAPI 👉 getProfileRequest ➡️ data ↩`, data);

      if (!isEmpty(data)) {
        /* CASE 1 - BEGIN PENDING_PII */
        // data = {
        //   ...data,
        //   status: 'PENDING_PII',
        // };
        /* CASE 1 - END */
        /* CASE 2 - BEGIN PENDING_ID_DOCUMENTS */
        // data = {
        //   ...data,
        //   status: 'PENDING_ID_DOCUMENTS',
        // };
        /* CASE 2 - END */
        /* CASE 3 - KYC */
        // data = {
        //   ...data,
        //   kycRefresh: true,
        // };
        /* CASE 3 - END */
        return { data };
      }
      return null;
    } catch (error) {
      console.error(
        `🔥 useProfileAPI ❌ getProfileRequest ➡️ ERROR ↩`,
        error?.message
      );
    }
  };

  const getProfileOccupationRequest = async (token) => {
    try {
      let { data } = await api.getOccupation(token);
      console.log(
        `⭐ useProfileAPI 👉 getProfileOccupationRequest ➡️ data ↩`,
        data
      );
      if (!isEmpty(data)) {
        /* CASE 1 - BEGIN */
        // data = {
        //   ...data,
        //   job: 'RETIRED',
        //   previousJob: 'ACCOUNTANT',
        // };
        /* CASE 1 - END */
        /* CASE 2 - BEGIN */
        // data = {
        //   ...data,
        //   job: 'RETIRED',
        //   previousJob: '',
        // };
        /* CASE 1 - END */
        const occupationInit = configOccupation?.find(
          (o) => o.key === data.job
        );
        const previousOccupationInit = configOccupation?.find(
          (o) => o.key === data.previousJob
        );
        const occupation = {
          job: occupationInit,
          prevJob: previousOccupationInit,
        };
        setProfileOccupation(occupation);
        return occupation;
      }
      return null;
    } catch (error) {
      console.error(
        `🔥 useProfileAPI ❌ getProfileOccupationRequest ➡️ ERROR ↩`,
        error?.message
      );
    }
  };

  const saveProfileDocsRequest = async (
    token,
    documentUploadResponses = []
  ) => {
    try {
      let { data } = await api.saveProfileDocs(token, documentUploadResponses);
      console.log(`⭐ useProfileAPI 👉 saveProfileDocsRequest ➡️ data ↩`, data);

      if (!isEmpty(data)) {
        return { data };
      }
      return null;
    } catch (error) {
      console.error(
        `🔥 useProfileAPI ❌ saveProfileDocsRequest ➡️ ERROR ↩`,
        error?.message
      );
    }
  };

  const saveProfileInformationRequest = async (
    token,
    profileInformationPayload = {},
    errorCallback = FUNC_DEFAULT
  ) => {
    try {
      const reponse = await api.updateProfile(token, profileInformationPayload);
      const { data } = reponse || {};
      console.log(
        `⭐ useProfileAPI 👉 saveProfileInformationRequest ➡️ data ↩`,
        data
      );

      if (!isEmpty(data)) {
        return { data };
      }
      return null;
    } catch (error) {
      console.error(
        `🔥 useProfileAPI ❌ saveProfileInformationRequest ➡️ ERROR ↩`,
        error?.message
      );
      errorCallback?.();
    } finally {
      setLoading(false);
    }
  };

  return {
    getProfileRequest,
    saveProfileDocsRequest,
    getProfileOccupationRequest,
    saveProfileInformationRequest,
  };
};

export default useProfileAPI;
